import type { ReactNode } from 'react';

export const symbol_speaker_phone: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-741q-42 0-83.5 12T319-692q-10.79 8-23.9 7-13.1-1-22.1-10-9-9-8-20.5t11-19.5q42-31 94-48.5T480-801q58 0 110 17.5t94 48.5q10 8 10.5 19.5T686-695q-9 9-21.75 10T641-692q-36-25-77.5-37T480-741Zm-131-98q-61 22-112 62-11 8-23.5 8.5T192-777q-9-9-8.5-22t10.5-21q57-46 132.5-73.5T480-921q78 0 153.5 27.5T766-820q10 8 11 20.83 1 12.84-8 22.17-9 9-22 8.5t-24-8.5q-51-40-112-62t-131-22q-70 0-131 22Zm20 759q-24 0-42-18t-18-42v-379q0-24 18-42t42-18h221q24 0 42 18t18 42v379q0 24-18 42t-42 18H369Zm221-60v-379H369v379h221Zm0 0H369h221Z"
		/>
	</svg>
);
